import Vue from "vue";

export default {
	state: {
		languages: []
	},
	mutations: {
		setLanguagesOnState(state, languages) {
			state.languages = languages;
		}
	},
	actions: {
		getLanguages({ commit }) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("language")
					.then((response) => {
						commit("setLanguagesOnState", response.data.data.languages);
						resolve(response.data.data.languages);
						this.state.loading = false;
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		}
	},
	getters: {
		languages({ languages }) {
			return languages;
		}
	}
};
